module.exports = __webpack_public_path__ + "img/Indonesia-11.52725298.jpg";